import axios from 'axios'
import { 
    setPlans,
    setPlan,
    setSelectedSOPs,
    setSOPs,
    setAwaitingApproval,
    setFinalSOPs,
    setToEdit,
    setStepsCompleted,
    setProcesses,
    setTags,
    setObjTags,
  } from '../redux/plan'
import { setSelectedModule } from '../redux/navigation'
import _ from 'lodash'

export const baseApiAuth = 'https://auth-qa.iqkitchen.biz'
export const baseURL = 'https://api-haccp-qa.iqkitchen.biz'
export const baseIqopsAPI = 'https://iqops-qa.iqkitchen.biz';
// export const baseApiAuth = 'http://saas.api.local'
// export const baseURL = 'http://haccp.api.local'
// export const baseIqopsAPI = "http://iqops.api.local" // demo
export const api = `${baseURL}/api/v1`
export const apiIQOPS = `${baseIqopsAPI}/api/v1`

export const getCompanyDetails = async (token) => {
  const url = `${apiIQOPS}/company/details`
  const res = await axios.get(
              url,
              { 
                headers: { Authorization : `Bearer ${token}` }
              })
  return res.data
}

export const uploadPlanToGDocs = async (token, form) => {
  const url = `${apiIQOPS}/export/google_plan`
  const res = await axios.post(
              url, form,
              {
                headers: { Authorization : `Bearer ${token}` }
              })
  return res.data.id
}

export const saveTag = async (token, params) => {
  const res = await axios.post(
    `${api}/tag`,
    params,
    {
      headers: { Authorization: `Bearer ${token}` }
    },
  )
  getTags(token, res.data)
}

export const savePlan = async (token, doc, action, showAlert = true) =>  {
  doc.updated = new Date()
  const res = await axios.post(
    `${api}/sopsqav2`, 
    doc, 
    {
      headers: { Authorization: `Bearer ${token}` }
    },
  )
  const actualData = res.data[0]
  
  setPlan({
    ...doc,
    _id: actualData._id,
    _rev: actualData._rev
  })
  localStorage.setItem('plan', JSON.stringify({
    openPlan: true,
    plan: doc,
  }))
  setSelectedSOPs(doc.sops)
  await getAllPlans(token)
  if(showAlert)
    alert(`Your plan was sucessfully ${action}`)
  return res.data
}

export const updatePlanSops = async (token, doc, plan) => {
  plan.sops.forEach( (currSop, indx) => {
    if(currSop._id === doc._id){
      plan.sops[indx] = {
        _id: doc._id,
        _rev: doc._rev,
        title: doc.title,
      }
    }
  })
  await savePlan(token, plan, null, false)
}

export const getSopType = async (token, params) => {
  const url = `${api}/getSopTypes`
  const res = await axios.post(url, params ,
    {
      headers: { Authorization : `Bearer ${token}` }
    }
  )
  return res.data
}

export const convertPlanToDocx = async (token, params) => {
  const url_ = `${api}/getDocxFromHtml`
  const res = await axios.post(url_, params,{
                headers: { Authorization : `Bearer ${token}` },
                responseType: 'blob',
              })
  return res.data
}

export const setAttachments = async (token, attachments) => {
  const url = `${api}/setAttachment`
  const res = await axios.post(
              url, attachments,
              {
                headers: { Authorization : `Bearer ${token}` }
              })
}

export const getAttachments = async (token) => {
  const url = `${api}/getattachments`
  const res = await axios.get(url, {headers:{ Authorization: `Bearer ${token}` }})
  return res.data
}

export const uploadFile = async (token, form) => {
  const url = `${api}/upload`
  const res = await axios.post(
              url, form,
              {
                headers: { Authorization : `Bearer ${token}` }
              })
  return res.data.path
}

export const getAllPlans = async (token) => {
    let url = `${api}/filteredplans`
    const res = await axios.get(
        url, 
        {
          headers: { Authorization : `Bearer ${token}` }
        },
      )
    setPlans(res.data)
    getProcesses(res.data)
    return res.data
  }
const getProcesses = (datos) => {
    const proc = _.compact(_.uniq(datos.map(x=>x.process)))
    setProcesses(proc)
  }

  export const getSOPS = async (token) =>  {
    await axios.get(
      `${api}/tagsbytypev2`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      },
    ).then(
      result => {
        setSOPs(result.data)
        getTags(token)
      }
    )
  }

  const getTags = async (token, datos = null) => {
    const newTags = {};
    if(datos === null){
      const resp = await axios.get(
        `${api}/tags`, 
        {
          headers: { Authorization: `Bearer ${token}` }
        },
      );
      datos = resp.data;
    }
    datos.forEach( data => {
      newTags[data.category] = data.tags.map( elem => elem.tag )
    })

    setObjTags(newTags)
    setTags(newTags)
  }
  
  

  export const getProposals = async (token) =>  {
    await axios.get(
      `${api}/docsbytype?key=%22proposal%22`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      },
    ).then(result => {
      setAwaitingApproval(result.data)
    })
  }

  export const getFinal = async (ids, token) =>  {
    ids.length > 0 ? setStepsCompleted([true, true, true]) : setStepsCompleted([true, true, false])
    await axios.post(
      `${api}/id`,
      {
        ids
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      },
    ).then(
      result => {
        setFinalSOPs(result.data)
        setSelectedModule('Preview')
      }
    )
  }

  export const getSOPByID = async (id, token) => {
    const res = await axios.get(
      `${api}/id/${id}`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      },
    )
    return res.data;
  }

  export const getSingle = (id, token) =>  {
    axios.get(
      `${api}/id/${id}`, 
      {
        headers: { Authorization: `Bearer ${token}` }
      },
    ).then(result => {
     // console.log(result)
      result.data.hasOwnProperty('doctype') ?
        setToEdit(
          {
            data:result.data, 
            doctype:result.data.doctype
          }
        )
      :
        result.data.hasOwnProperty('text') ?
        setToEdit(
          {
            data:result.data, 
            doctype:'Doc'
          }
        )
        :
        setToEdit(
          {
            data:result.data, 
            doctype:'SOP'
          }
        )
        setSelectedModule('Editor')
      }
    ).catch(
      err => {
        alert('The Document presented the following error: ' + err.response.data.reason)
      }
    )
  }

  export const getSOPforReplacement = async (sop) =>  {
    const url = baseURL + sop
    const doc = await axios.get(url, 
      {withCredentials: true}
    ).catch(
      err => {
        alert('There was an error: ' + err.response.data.reason)
      }
    )
    await getProposals()
    return doc.data
  }

  export const saveSOP = async (doc, token) =>  {
    doc.updated = new Date()
    await axios.post(
        `${api}/sopsqav2`, doc, 
        {
          headers: { Authorization: `Bearer ${token}` }
        },
    )
    alert('Your changes has been saved')
    await getProposals(token)
    setSelectedModule('Approve')
}

  export const archiveSOP = async (doc) =>  {
      doc.updated = new Date()
      await axios.post(
        'http://haccp-dev.iqkitchen.biz/couch/archive', doc, 
        {withCredentials: true}
      ).then(
          (result) => {
              alert('Your SOP was sucessfully archived')
          }
      )
  }